import React from "react";
import "./Hero.css";
import GlobeComponent from "./Globe";
import { Link } from "react-scroll";
import { useNavigate } from "react-router-dom";

export default function Hero() {

  const navigate = useNavigate();

  return (
    <section className="hero">

      <div className="hero-left">

        <p className="since">SINCE 1998</p>

        <h1>
          Your Offshore
          <br />
          Development Center
          <br />
          for <span>Scalable Software Solutions</span>
        </h1>

        <p className="subtitle">
          Delivering enterprise software, digital transformation,
          IT staffing, managed IT services and cloud solutions
          trusted by businesses worldwide.
        </p>

        <div className="hero-buttons">

          <Link
            to="contact"
            smooth={true}
            duration={700}
            offset={-80}
          >
            <button className="primary-btn">
              Get In Touch
            </button>
          </Link>

          <button
            className="secondary-btn"
            onClick={() => navigate("/services")}
          >
            Explore Services
          </button>

        </div>

      </div>

      <div className="hero-right">

        <div className="globe-wrapper">
          <GlobeComponent />
        </div>

      </div>

    </section>
  );
}